import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, ShieldCheck } from "lucide-react";
import { team } from "../data/team";
import { businessInfo } from "../mock";

// E-E-A-T author box for blog posts. Maps the post's author (first name)
// to the team member so readers see who wrote it, their credentials, and
// a link to the full bio — a strong trust signal for insurance (YMYL) content.
const AuthorBox = ({ author }) => {
  const member =
    team.find((m) => m.name.toLowerCase() === String(author).toLowerCase()) ||
    team[0];

  const flLicense = member.licenses?.florida || businessInfo.licenses.florida;
  const gaLicense = member.licenses?.georgia;

  return (
    <div
      className="mt-12 bg-[#0F0F0F] border border-white/10 p-6 sm:p-7 flex flex-col sm:flex-row gap-6"
      data-testid="blog-author-box"
    >
      <img
        src={member.photo}
        alt={`${member.name} — ${member.role} at Claim Beast Public Adjusters`}
        className="h-24 w-24 sm:h-28 sm:w-28 object-cover shrink-0 grayscale"
      />
      <div>
        <div className="flex items-center gap-2 text-[#E11D26] text-xs font-bold tracking-[0.25em] uppercase">
          <BadgeCheck className="h-4 w-4" /> Written by a Licensed Public Adjuster
        </div>
        <h3
          className="mt-2 text-white text-xl font-black uppercase"
          style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
        >
          {member.name} · {member.role}
        </h3>
        <p className="mt-2 text-white/75 text-sm leading-relaxed">
          {Array.isArray(member.bio) ? member.bio[1] || member.bio[0] : member.bio}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1 text-white/50 text-xs">
          <span className="flex items-center gap-1.5">
            <ShieldCheck className="h-3.5 w-3.5 text-[#E11D26]" />
            FL License {flLicense}
          </span>
          {gaLicense && <span>GA License {gaLicense}</span>}
          <span>{member.yearsExperience} years experience</span>
        </div>
        <Link
          to={`/about#${member.slug}`}
          className="mt-4 inline-flex items-center gap-2 text-[#E11D26] hover:text-white text-xs font-bold tracking-[0.2em] uppercase transition-colors"
          data-testid="blog-author-about-link"
        >
          Read Full Bio →
        </Link>
      </div>
    </div>
  );
};

export default AuthorBox;
